<div class="billing-card billing-card--dark">
  <svg class="wallet-illustration" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="10" y="16" width="56" height="38" rx="8" fill="rgba(255,255,255,0.10)"/>
    <rect x="18" y="26" width="60" height="46" rx="10" fill="rgba(255,255,255,0.16)" stroke="rgba(255,255,255,0.28)" stroke-width="1.5"/>
    <path d="M18 40H78V44C78 47.3137 75.3137 50 72 50H24C20.6863 50 18 47.3137 18 44V40Z" fill="rgba(255,255,255,0.10)"/>
    <circle cx="68" cy="45" r="5" fill="var(--color-primary-500)"/>
  </svg>

  <span class="billing-card__overline">Wallet balance</span>
  <span class="billing-card__balance" [class.billing-card__balance--negative]="wallet.status === 'overdrawn'">
    {{ wallet.balance }} {{ wallet.currency | uppercase }}
  </span>

  @if (wallet.status === 'active') {
    <span class="wallet-status-badge wallet-status-badge--active">
      <span class="wallet-status-badge__dot"></span> Active
    </span>
  } @else {
    <span class="wallet-status-badge wallet-status-badge--negative">
      <span class="wallet-status-badge__dot"></span> Overdrawn
    </span>
  }

  <div class="billing-card__actions">
    <a class="btn--primary" routerLink="/billing">Add funds</a>
  </div>
</div>
